import { ReferanceAsyncSelect } from './referance-async-select'

export function SelectReferanceCode10ZaraHome({ name }) {
  return <ReferanceAsyncSelect name={name} labelCategory="ZARAHOME EKSTRA KARTI" />
}
